import React, {FC} from 'react';

import {EventHandler} from '../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {GenericDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/genericDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {getTimeFormat} from '../../../../../libs/shared/core/src/store/data/preferences/commonPreferencesSelectors';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {RelativeDateTimeFormatsEnum} from '../../../../../libs/shared/ui/src/components/datetime/relativeDateTimeFormatter';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {DateTimeFormatter} from '../../../../../srcCommon/formatters/dateTime/dateTimeFormatter';
import {useAppDispatch, useAppSelector} from '../../../../helpers/appReduxHelpers';
import {LocalPreferencesFlagsEnum} from '../../../../models/api/localPreferencesModel';
import {toggleFlagAction} from '../../../../store/data/localPreferences/localPreferencesActions';
import {getDateTimeFormat} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {InvertedDateTimeFormatter} from './invertedDateTimeFormatter';

/*
 * Props.
 */

interface InteractiveDateTimeFormatterProps {
  className?: string;
  /** The date to format. */
  value: number;
  /** The format to use for relative dates. */
  relativeFormat: RelativeDateTimeFormatsEnum;
}

/*
 * Component.
 */

export const InteractiveDateTimeFormatter: FC<InteractiveDateTimeFormatterProps> = (props) => {
  const format = useAppSelector(getDateTimeFormat);
  const timeFormat = useAppSelector(getTimeFormat);
  const dispatch = useAppDispatch();

  const {trackDataEvent} = useDataEventTracking();
  // Build the method to toggle the expanded state.
  const onClick: EventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    trackDataEvent(DataEventActionsEnum.CLICK, GenericDataEventObject.TIMESTAMP);
    dispatch(toggleFlagAction(LocalPreferencesFlagsEnum.ABSOLUTE_DATETIME));
  };
  return (
    <TooltipCoordinator
      render={() => <InvertedDateTimeFormatter timeFormat={timeFormat} value={props.value} format={format} />}
    >
      <ChromelessButton onClick={onClick} className={props.className}>
        <DateTimeFormatter value={props.value} format={format} relativeFormat={props.relativeFormat} />
      </ChromelessButton>
    </TooltipCoordinator>
  );
};
